export default "__VITE_ASSET__iHTV2450__"